const phoneNumberMask = [
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const ssnMask = [
  /\d/, // allows 0–9
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

const inputMasks = {
  phoneNumberMask,
  ssnMask
};

export default inputMasks;
